// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.open-house-container {
  width: 100%;
  font-family: "Proxima Nova", sans-serif;
}
.open-house-container .date-today {
  padding: 15px 8px;
  border-radius: 8px;
  display: flex;
  margin: 0 8px;
  margin-top: 16px;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
}
.open-house-container .date-today p {
  margin: 0;
}
.open-house-container .date-today p:first-child {
  color: #2A2A2A;
}
.open-house-container .date-today p:last-child {
  color: #5F5F5F;
}
.open-house-container .date-today p:last-child span {
  color: #949494;
}
.open-house-container .open-house-sched {
  display: flex;
}
.open-house-container .open-house-sched .availability {
  display: flex;
  border-right: 1px dashed #BEBEBE;
  align-items: center;
  padding: 0 16px;
  padding-bottom: 16px;
}
.open-house-container .open-house-sched .availability .time {
  margin: 0;
  font-weight: 700;
  color: #5F5F5F;
  font-size: 10px;
}
.open-house-container .open-house-sched .open-house {
  display: flex;
  flex: 1 1;
  background: #BEBEBE;
  height: 40px;
  border-radius: 8px;
  margin-left: 16px;
  display: flex;
  align-items: center;
  padding: 15px 16px;
  margin-right: 8px;
  margin-bottom: 16px;
}
.open-house-container .open-house-sched .open-house.active {
  background: #EFDFF7;
}
.open-house-container .open-house-sched .open-house.active > p {
  color: #B15DD9;
}
.open-house-container .open-house-sched .open-house > p {
  margin: 0;
  font-size: 10px;
  color: white;
  font-weight: 700;
}

.saved-offer-buttons {
  display: flex;
  width: 100%;
}
.saved-offer-buttons > button {
  width: 100%;
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: center;
}
.saved-offer-buttons > button.save-button {
  color: #6C767C;
  border: 2px solid #BEBEBE;
  background: white;
  margin-right: 25px;
}
.saved-offer-buttons > button.save-button:hover {
  opacity: 0.75;
}
.saved-offer-buttons > button.save-button.saved {
  color: var(--primary-color-1);
  border: 2px solid var(--primary-color-1);
}
.saved-offer-buttons > button > svg {
  margin-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/routes/Listing/modules/ListingDetail/modules/OpenHouse/openHouse.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,uCAAA;AACJ;AACI;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACD,eAAA;EACA,gBAAA;AACP;AAAO;EAAI,SAAA;AAGX;AAFO;EACC,cAAA;AAIR;AAFO;EACC,cAAA;AAIR;AAHQ;EACI,cAAA;AAKZ;AADI;EACI,aAAA;AAGR;AAFQ;EACI,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAIZ;AAHY;EACI,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAKhB;AAFQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAIZ;AAHY;EACI,mBAAA;AAKhB;AAJgB;EACI,cAAA;AAMpB;AAHY;EACI,SAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAKhB;;AACA;EACI,aAAA;EACA,WAAA;AAEJ;AADI;EACI,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAGR;AAFQ;EACI,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAIZ;AAHY;EACI,aAAA;AAKhB;AAHY;EACI,6BAAA;EACA,wCAAA;AAKhB;AAFQ;EACI,kBAAA;AAIZ","sourcesContent":[".open-house-container {\r\n    width: 100%;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n\r\n    .date-today {\r\n        padding: 15px 8px;\r\n        border-radius: 8px;\r\n        display: flex;\r\n        margin: 0 8px;\r\n        margin-top: 16px;\r\n        background-color: white;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n       font-size: 10px;\r\n       font-weight: 700;\r\n       p { margin: 0; }\r\n       p:first-child {\r\n        color: #2A2A2A;\r\n       }\r\n       p:last-child {\r\n        color: #5F5F5F;\r\n        span {\r\n            color: #949494;\r\n        }\r\n       }\r\n    }\r\n    .open-house-sched {\r\n        display: flex;\r\n        .availability {\r\n            display: flex;\r\n            border-right: 1px dashed #BEBEBE;\r\n            align-items: center;\r\n            padding: 0 16px;\r\n            padding-bottom: 16px;\r\n            .time {\r\n                margin: 0;\r\n                font-weight: 700;\r\n                color: #5F5F5F;\r\n                font-size: 10px;\r\n            }\r\n        }\r\n        .open-house {\r\n            display: flex;\r\n            flex: 1;\r\n            background: #BEBEBE;\r\n            height: 40px;\r\n            border-radius: 8px;\r\n            margin-left: 16px;\r\n            display: flex;\r\n            align-items: center;\r\n            padding: 15px 16px;\r\n            margin-right: 8px;\r\n            margin-bottom: 16px;\r\n            &.active {\r\n                background: #EFDFF7;\r\n                > p {\r\n                    color: #B15DD9;\r\n                }\r\n            }\r\n            > p { \r\n                margin: 0; \r\n                font-size: 10px;\r\n                color: white;\r\n                font-weight: 700;\r\n            }         \r\n        }\r\n    }\r\n}\r\n\r\n.saved-offer-buttons {\r\n    display: flex;\r\n    width: 100%;\r\n    > button {\r\n        width: 100%;\r\n        display: flex;\r\n        flex: 1;\r\n        align-items: center;\r\n        justify-content: center;\r\n        &.save-button {\r\n            color: #6C767C;\r\n            border: 2px solid #BEBEBE;\r\n            background: white;\r\n            margin-right: 25px;\r\n            &:hover {\r\n                opacity: .75;\r\n            }\r\n            &.saved {\r\n                color: var(--primary-color-1);\r\n                border: 2px solid var(--primary-color-1);\r\n            }\r\n        }\r\n        > svg {\r\n            margin-right: 15px;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
